import React from "react";
import {
  findMatte, matteWindow, safeAreaRects,
  MATTE_BAR_FILL, MATTE_GUIDE_SHADE, MATTE_GUIDE_LINE, SAFE_AREA_LINE,
} from "../constants/storyboard";

/**
 * Letterbox bars, a crop guide, and/or safe areas over a storyboard frame.
 * Sized to the frame's window inside its border, like the art. The page
 * renderer draws the same shapes (drawFrameMatte) for exports.
 */
const FrameMatte = ({ width, height, storyboard }) => {
  const matte = findMatte(storyboard?.matteKey);
  const win = matte.ratio ? matteWindow(width, height, matte.ratio) : null;
  const safe = storyboard?.safeAreas ? safeAreaRects(win?.width ?? width, win?.height ?? height) : [];
  if (!win && safe.length === 0) return null;

  // The matte window cut out of the frame (even-odd fill)
  const outside = win
    ? `M0 0H${width}V${height}H0Z M${win.x} ${win.y}h${win.width}v${win.height}h${-win.width}Z`
    : null;
  const ox = win?.x ?? 0;
  const oy = win?.y ?? 0;

  return (
    <svg
      aria-hidden="true"
      width={width}
      height={height}
      style={{ position: "absolute", left: 0, top: 0, pointerEvents: "none", zIndex: 25 }}
    >
      {outside && (
        <path d={outside} fillRule="evenodd" fill={matte.mode === "bars" ? MATTE_BAR_FILL : MATTE_GUIDE_SHADE} />
      )}
      {win && matte.mode === "guide" && (
        <rect x={win.x + 0.5} y={win.y + 0.5} width={win.width - 1} height={win.height - 1}
          fill="none" stroke={MATTE_GUIDE_LINE} strokeWidth={1} strokeDasharray="5 3" />
      )}
      {safe.map((r) => (
        <rect key={r.key} x={ox + r.x} y={oy + r.y} width={r.width} height={r.height}
          fill="none" stroke={SAFE_AREA_LINE} strokeWidth={0.75} strokeDasharray={r.key === "title" ? "2 2" : "6 3"} />
      ))}
    </svg>
  );
};

export default FrameMatte;
